import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthContext';

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('A useAuth csak az AuthProvider elemen belül használható.');
  }

  return context;
};
